<div *ngIf="loading" class="subscription-loader">
    <div class="loading-spinner">
        <div class="progress" alt="Loading...">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
</div>
<div>
    <app-freshpass-title></app-freshpass-title>
</div>
<div *ngIf="isServiceError" class="form-group">
    <div data-testid="error-message" class="error-message-center">
        {{API_FAIL_ERROR_MESSAGE}}
    </div>
</div>
<div class="container" id="paymentFrame"></div>
<div *ngIf="backToManage" class="row col-md-auto">
    <div class="container-fluid">
        <div class="row abs-no-gutters">
            <div class="mt-5 mr-5">
                <span>
                    <button (click)="openManageScreen()"
                            class="btn btn-primary btn-block body-m--extra-bold">
                        {{properties.partnersBanners.continue}}
                    </button>
                </span>
            </div>
        </div>
    </div>
</div>
